// extracted by mini-css-extract-plugin
export var dividerLine = "_9l-3";
export var itemImage = "_9l-9";
export var lightDivider = "_9l-4";
export var modalContent = "_9l-5";
export var modalContentCompact = "_9l-6";
export var productCard = "_9l-a";
export var productImage = "_9l-b";
export var productImageCompact = "_9l-7";
export var productImagePlaceholder = "_9l-c";
export var productImagePlaceholderCompact = "_9l-8";
export var progressBarBackground = "_9l-1";
export var progressBarContainer = "_9l-0";
export var progressBarFill = "_9l-2";